<script lang="ts" setup>
import logo from '@csm/template/assets/logo/misja.svg?raw'

withDefaults(
  defineProps<{
    width?: number
  }>(),
  {
    width: 108,
  },
)
</script>

<template>
  <router-link
    to="/"
    class="app-logo select-none text-inherit"
    :style="{
      display: 'block',
      width: '100%',
      maxWidth: `${width}px`,
      lineHeight: 0,
    }"
    v-html="logo"
  />
</template>

<style lang="scss" scoped>
.app-logo {
  transition: opacity 0.3s;

  &:hover {
    opacity: .6;
  }
}
</style>
